module.exports = __webpack_public_path__ + "img/1491349699.4f13ce35.jpg";